import { render, staticRenderFns } from "./rating-table.vue?vue&type=template&id=44f1419c&scoped=true&lang=pug"
import script from "./rating-table.vue?vue&type=script&lang=ts"
export * from "./rating-table.vue?vue&type=script&lang=ts"
import style0 from "./rating-table.vue?vue&type=style&index=0&id=44f1419c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f1419c",
  null
  
)

export default component.exports